/**
 * Created by zj on 2017/8/8.
 */
import Component from "../../../../../lib/component";
import template from './calendar.schedule.item.html';
import './calendar.schedule.item.scss';

import {PMAPI} from '../../../../../lib/postmsg';
import CalendarRemindTaskItem from '../../calendar.subcomponent/calendar.table.grid/calendar.remind.task.item/calendar.remind.task.item';
import MSG from "../../../../../lib/msgbox";


let config = {
    template: template,
    data: {
        dayDate: '',
        dayScheduleList: [],
    },
    actions: {
        //获得日程数据
        getSchedule: function(startDate, endDate) {
            if( startDate === '' || endDate === '' ){
                alert( '时间不能为空。' );
                return;
            }
            if( startDate > endDate ){
                alert( '起始时间不能大于结束时间。' );
                return
            }
            PMAPI.sendToParent({from_date: startDate, to_date: endDate});
        }

    },
    afterRender: function() {
        let weekDay = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        let myDate = new Date(Date.parse(this.data.dayDate));
        this.el.find('.day-date-title').html(this.data.dayDate + '&emsp;('+ weekDay[myDate.getDay()] +')');
        this.data.dayScheduleList.forEach(item => {
            let remindTaskData = {},
                isHomeCalendar = false,
                isFinishedTask = false,
                isNone = false;
            if(item && item['data3show']) {
                remindTaskData = item['data3show'][0][0];
            }
            if(item && item.tableName === "首页日历事件表"){
                isHomeCalendar = true;
                if(remindTaskData['selectLabel']) {
                    let checkText = '已';
                    let uncheckText = '未';
                    if(remindTaskData['selectLabel'].indexOf(checkText) >= 0) {
                        isFinishedTask = true;
                    }else if (remindTaskData['selectLabel'].indexOf(uncheckText) >= 0) {
                        isFinishedTask = false
                    }
                } else {
                    isNone = true;
                }
            }else{
                if(remindTaskData === undefined) {
                    MSG.alert('undefined!该表未设置代表字段');
                }
                if(remindTaskData['selectLabel']) {
                    isFinishedTask = true;
                } else {
                    isNone = true;
                }
            }
            this.append(new CalendarRemindTaskItem({
                data:{
                    remindTaskItemData: item,
                    type: 'schedule',
                    remindTaskData: remindTaskData,
                    isHomeCalendar: isHomeCalendar,
                    isFinishedTask: isFinishedTask,
                    isNone: isNone
                }}), this.el.find('.day-schedule-list'));

        })

    },
};
//
// class CalendarScheduleItem extends Component {
//     constructor(data, newconfig = {}) {
//         config.data.dayDate = data['dayDate'];
//         config.data.dayScheduleList = data['dayScheduleList'];
//         super($.extend(true ,{}, config, newconfig));
//     }
// }
//
// export default CalendarScheduleItem;
let CalendarScheduleItem = Component.extend(config);

export default CalendarScheduleItem;


// WEBPACK FOOTER //
// app/components/calendar/calendar.main/calendar.schedule/calendar.schedule.item/calendar.schedule.item.js